module.exports = __webpack_public_path__ + "img/start_search.645eb318.png";